export default __webpack_public_path__ + "static/src/assets/images/icons/quote_icon_watchlist.png";